import React from 'react';
import PinInput from 'react-pin-input';
import Typography from '../components/Typography';
import MyButton from '../components/Button';
import useIsDesktop from '../utils/hooks/useIsDesktop';
import { CloseOutlined } from '@ant-design/icons';
import { FormattedMessage } from 'react-intl';

const VerifyPinCard = (props) => {
  const { onVerify, setVerifyCode, verifyCode, phone, handleCancelVerify } = props;
  // const [pin, setPin] = useState("");
  const formattedPhone = phone.slice(0, 3) + '-XXX-X' + phone.slice(7);

  const isDesktop = useIsDesktop();
  const Lang = localStorage.getItem('lang');

  const handleChangePin = (value) => {
    // setPin(value);
    setVerifyCode(value);
  };
  //console.log('formattedPhone = ', formattedPhone);

  return (
    <div>
      <div
        style={{
          borderRadius: '9px',
          backgroundColor: 'white',
          padding: '15px',
          maxWidth: isDesktop ? '550px' : '92%',
          width: isDesktop ? '550px' : '400px',
        }}
      >
        <div style={{ textAlign: 'right' }} onClick={handleCancelVerify}>
          <CloseOutlined style={{ fontSize: '20px', cursor: 'pointer' }} />
        </div>
        <div
          style={{
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'center',
          }}
        >
          <div className='d-flex flex-column justify-content-center text-center'>
            <div className={isDesktop ? 'py-5' : 'py-4'}>
              {Lang === 'TH' ? (
                <>
                  <Typography fontType='heading' size={isDesktop ? '45px' : '40px'} lineHeight='40px'>
                    <FormattedMessage id='titleCode' defaultMessage='Code' />
                  </Typography>
                  <Typography fontType='heading' size={isDesktop ? '45px' : '40px'} lineHeight='40px' className='py-2'>
                    <FormattedMessage id='titleVerification' defaultMessage='Verification' />
                  </Typography>
                </>
              ) : (
                <>
                  <Typography fontType='heading' size={isDesktop ? '45px' : '40px'} lineHeight='40px' className='py-2'>
                    <FormattedMessage id='titleVerification' defaultMessage='Verification' />
                  </Typography>
                  <Typography fontType='heading' size={isDesktop ? '45px' : '40px'} lineHeight='40px'>
                    <FormattedMessage id='titleCode' defaultMessage='Code' />
                  </Typography>
                </>
              )}
            </div>
            <Typography size={isDesktop ? '14px' : '12px'} className={isDesktop ? 'py-2 px-4' : ''}>
            <FormattedMessage id='textVerification' defaultMessage='We have sent the verification code to' />
            </Typography>
            <Typography size={isDesktop ? '14px' : '12px'} className={isDesktop ? 'py-2 px-4' : ''}>
            <FormattedMessage id='textVerification2' defaultMessage='your mobile number:' />{' '}{formattedPhone}
            </Typography>
            <div className={isDesktop ? 'my-4 py-4' : 'my-4 py-2'}>
              <PinInput
                inputStyle={{
                  border: '1px solid rgba(180, 180, 180, 0.2) ',
                  boxShadow: '0px 0px 2px 1px rgba(240, 240, 250, 0.2), 0px 0px 2px 1px rgba(238, 238, 240, 1)',
                  borderRadius: '8px',
                  margin: isDesktop ? '12px' : '2%',
                  height: isDesktop ? '59px' : '40px',
                  width: isDesktop ? '59px' : '40px',
                  fontSize: isDesktop ? '20px' : '14px',
                  fontWeight: 'normal',
                }}
                length={4}
                focus
                // disabled
                // secret
                // ref={(p) => (this.pin = p)}
                type='numeric'
                value={verifyCode}
                onChange={handleChangePin}
              />
            </div>
            <div style={{ width: '100%' }}>
              <MyButton isPrimary style={{ width: isDesktop ? '100%' : '100%', height: '120%' }} onClick={onVerify}>
              <FormattedMessage id='btnConfirm' defaultMessage='Confirm' />
              </MyButton>
            </div>
            <p style={{ marginBottom: '11px' }}></p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default VerifyPinCard;
